import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { RootState } from "../store";

export interface AppContext {
	lastUpdate: ETLLastUpdate[],
    searchKeywords: string[],
	userPreferences: UserPreferences
}
export interface UserPreferences {
	priorizeStatusReports: boolean;
}
export interface ETLLastUpdate {
	rank: number;
	label: string;
	lastUpdate: Date;
	frequency: string;
}

export interface DBLog{
    action: string;
    data: string;
}

const initialAppContext: AppContext = {
	lastUpdate: [],
    searchKeywords: [],
	userPreferences: {
        priorizeStatusReports: false
	}
}

export const appContextSlice = createSlice({
    name: 'appContext',
    initialState: initialAppContext,
    reducers: {
        getAppContext: (state, lastUpdates: PayloadAction<ETLLastUpdate[]>) => {
            state.lastUpdate = lastUpdates.payload
        },
        getSearchKeywords:(state, labels: PayloadAction<string[]>) =>{
            state.searchKeywords = labels.payload
        },
        postLogDB:(state,log: PayloadAction<DBLog> ) =>{

        }
    }
})

export const appContextApi = createApi({
    reducerPath: 'AppContextApi',
    tagTypes: ['ETLUpdates', 'Keywords'], // used to refresh => see Invalidate tags
    // SEE ALSO : https://redux-toolkit.js.org/rtk-query/api/createApi#onquerystarted
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.PUBLIC_URL}/api/AppSettings/`,
        prepareHeaders: (headers, { getState }) => {

            const accessToken = (getState() as RootState).userStateReducer.accessToken;
            // const context = state.Contexte;

            // If we have a token set in state, let's assume that we should be passing it.
            if (accessToken !== '') {
                headers.set('authorization', `Bearer ${accessToken}`)
            }

            if (!headers.has("accept")) {
                // headers.set("accept", "application/json");
            }
            return headers;
        },
    }),
    endpoints: (build) => ({
        getAppContext: build.query<ETLLastUpdate[], void>({
            queryFn: async (arg, api, extraOptions, baseQuery) => { // _arg (==> void 2 lines above instead of param), _queryApi, _extraOptions, fetchWithBQ
                const appContextQuery: QueryReturnValue<ETLLastUpdate[], FetchBaseQueryError, FetchBaseQueryMeta> = await baseQuery(`GetLastUpdates?version=${process.env.REACT_APP_VERSION}`) as QueryReturnValue<ETLLastUpdate[], FetchBaseQueryError, FetchBaseQueryMeta>;
                return appContextQuery.data ? { data: appContextQuery.data } : { error: appContextQuery.error}
            },
            providesTags: ['ETLUpdates'] // Cache key
        }),
        getSearchKeywords: build.query<string[], void>({
            queryFn: async (arg, api, extraOptions, baseQuery) => { // _arg (==> void 2 lines above instead of param), _queryApi, _extraOptions, fetchWithBQ
                const appSearchKeywords: QueryReturnValue<string[], FetchBaseQueryError, FetchBaseQueryMeta> = await baseQuery('GetSearchKeywords') as QueryReturnValue<string[], FetchBaseQueryError, FetchBaseQueryMeta>;
                return appSearchKeywords.data ? { data: appSearchKeywords.data } : { error: appSearchKeywords.error}
            },
            providesTags: ['Keywords'] // Cache key
        }),
        postLogDB: build.mutation<Date, Partial<DBLog>>({
            query: (newPost) => ({
              url: `LogAction?action=${newPost.action}&data=${newPost.data}`,
              method: 'POST',
              mode: 'cors'
            }),
          }),
    }),
})

export const appContextReducer = appContextSlice.reducer;

export const { getAppContext, getSearchKeywords, postLogDB } = appContextSlice.actions;

/* 
    ALERT VERY ANNOYING RTQK : React hook below is not generated when using :
    import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";

    IT MUST BE 
    import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

    https://stackoverflow.com/questions/69502501/redux-rtk-not-auto-generating-react-hooks
*/
export const { useGetAppContextQuery, useGetSearchKeywordsQuery, usePostLogDBMutation  } = appContextApi


